import axios from 'axios';
import { ROOT_URL } from '../../../../actions/root_url';

export const fetchZones = (warehouseid, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/warehouse/${warehouseid}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    const {
      Warehouse_Zone,
    } = res.data;
    success(Warehouse_Zone);
  }, err => {
    alert(err);
  })
}

export const fetchBins = (binId, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/warehouse/zone/${binId}/section/`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    const {
      data,
    } = res;
    success(data);
  }, err => {
    alert(err);
  })
}

export const fetchLevels = (section_id, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/warehouse/section/${section_id}/bin`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    const {
      data,
    } = res;
    success(data);
  }, err => {
    alert(err);
  })
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/api.js